import React from "react";
import { Link } from "react-router-dom";
import { Skeleton } from "@mui/material";

import { CanvasItem, DisplayCanvas } from "./index";
import { Contributors } from "components/avatar";
import { Canvas } from "types";

type CanvasTileProps = {
  canvas: Canvas;
};

export const CanvasTile: React.FC<CanvasTileProps> = ({ canvas }) => {
  return (
    <DisplayCanvas canvas={canvas}>
      {(shapes) =>
        shapes ? (
          <Link
            key={canvas.id}
            className="canvas-item"
            to={`/canvases/show/${canvas.id}`}
          >
            <CanvasItem canvas={canvas} shapes={shapes} active={false} />
            <Contributors shapes={shapes} />
          </Link>
        ) : (
          <div className="canvas-skeleton-list">
            {[...Array(3)].map((_, idx) => (
              <>
                <Skeleton key={idx} width="100%" animation="wave" />
              </>
            ))}
          </div>
        )
      }
    </DisplayCanvas>
  );
};
